import React from 'react'
import { useTranslation } from 'react-i18next'
import { Route, Switch } from 'react-router-dom'

import { Col, Row } from 'antd'

import { ProductIds } from 'core/application/commons/config'

import Content from '../../common/components/layout/Content'
import Footer from '../../common/components/layout/Footer'
import Layout from '../../common/components/layout/Layout'
import useOverrideProduct from '../../common/hooks/useOverrideProduct'
import useUrlQueryParam from '../../common/hooks/useUrlQueryParam'
import AccountHeader from '../AccountHeader'
import RightSection from '../RightSection'
import ForgetPasswordComponent from './ForgetPassword'
import InstructionsSent from './InstructionsSent'
import ResetPassword from './ResetPassword'

export const FORGOT_PASSWORD_PATH = '/forgot-password'

const ForgetPassword: React.FC = () => {
  const { t: translate } = useTranslation()
  const headerItems: string[] = [
    translate('admin-login.subtitle-1'),
    translate('admin-login.subtitle-2'),
    translate('admin-login.subtitle-3'),
  ]

  const productId = useUrlQueryParam('productId') ?? ProductIds.GroupHraId
  const currentProduct = useOverrideProduct(productId ?? ProductIds.GroupHraId)
  const headerTitle =
    currentProduct.productId == ProductIds.Perks
      ? 'PeopleKeep WorkPerks Management'
      : currentProduct.productId == ProductIds.QsehraId
      ? 'PeopleKeep QSEHRA Customer value'
      : 'PeopleKeep Group Coverage HRA Management'

  return (
    <Layout>
      <Content>
        <Row className="form-content form-content__full-height">
          <Col xs={23} sm={19} md={20} lg={14}>
            <Row justify="center">
              <Col
                span={24}
                sm={{ offset: 3 }}
                xs={{ offset: 1 }}
                md={{ offset: 5 }}
                lg={{ offset: 7 }}
                xl={{ offset: 10 }}
              >
                <div className="pt-16 mb-64">
                  <AccountHeader />
                </div>
              </Col>
            </Row>
            <Row className="form">
              <Col span={24}>
                <Switch>
                  <Route exact path={`${FORGOT_PASSWORD_PATH}/sent/:emailValue`} component={InstructionsSent} />
                  <Route exact path={`${FORGOT_PASSWORD_PATH}/reset-password`} component={ResetPassword} />
                  <Route exact path={`${FORGOT_PASSWORD_PATH}/:emailValue`} component={ForgetPasswordComponent} />
                  <Route path="/" component={ForgetPasswordComponent} />
                </Switch>
              </Col>
            </Row>
          </Col>
          <Col xs={0} lg={8} xl={8} className="account-right-section-login">
            <RightSection headerTitle={headerTitle} headerItems={headerItems} />
          </Col>
        </Row>
        <Footer className="absolute" />
      </Content>
    </Layout>
  )
}

export default ForgetPassword
